import * as types from "./type.js";
export default {
  [types.SET_LOADING](state, { flag, title }) {
    state[types.LOADING_SHOW] = flag;
    state[types.LOADING_TITLE] = title || types.LOADING_TITLE;
  },
  SET_VALUE(state, { name, value }) {
    state[name] = value;
  },
  officeWebUrl(state) {
    let url = ""
    switch (state.sid) {
      case 'mtu':
        url = "https://office.millcloud.cn"
        break;
      case 'scnu':case 'ils':
        url = "https://officeweb.scnu.edu.cn"
        break;
      case 'smu':
        url = "https://yl.aike.smu.edu.cn"
        break;
      case 'sysu':
        url = "https://preview.sysu.edu.cn"
        break;
      default:
        break;
    }
    state.officeWebUrl = url;
  }
};
